var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "a-tabs",
        {
          attrs: {
            "default-active-key": "1",
            size: "large",
            "tab-bar-style": { marginBottom: "24px", paddingLeft: "16px" }
          },
          on: { change: _vm.changeTabs }
        },
        [
          _c(
            "a-tab-pane",
            {
              key: "1",
              attrs: { loading: "true", tab: this.language["web.untreated"] }
            },
            [
              this.hanldSatus == 1
                ? _c("EmpDevAppApplyList", {
                    ref: "checkData",
                    attrs: { handleStatus: 0 }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "a-tab-pane",
            {
              key: "2",
              attrs: { loading: "true", tab: this.language["web.processed"] }
            },
            [
              this.hanldSatus == 2
                ? _c("EmpDevAppApplyList", {
                    ref: "checkData",
                    attrs: { handleStatus: 1 }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }